import React from 'react';

const SpecialDishSection: React.FC = () => {
  return (
    <section className="special-dish text-center" aria-labelledby="dish-label">
      <div className="special-dish-banner">
        <img
          src="/assets/images/special-dish-banner.jpg"
          width={940}
          height={900}
          loading="lazy"
          alt="special dish"
          className="img-cover"
        />
      </div>

      <div className="special-dish-content bg-black-10">
        <div className="container">
          <img
            src="/assets/images/badge-1.png"
            width={28}
            height={41}
            loading="lazy"
            alt="badge"
            className="abs-img"
          />

          <p className="section-subtitle label-2">Special Dish</p>

          <h2 className="headline-1 section-title">Stew Lamb Spine</h2>

          <p className="section-text">
            Including Lamb Spine, Chinese Cabbage, White Radish.
          </p>

          <div className="wrapper">
            <del className="del body-3">$65</del>

            <span className="span body-1">$58</span>
          </div>

          <a
            href="https://happy-valley-village.res-menu.com/menu"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="text text-1">View All Menu</span>

            <span className="text text-2" aria-hidden="true">
              View All Menu
            </span>
          </a>
        </div>
      </div>

      <img
        src="/assets/images/shape-4.png"
        width={179}
        height={359}
        loading="lazy"
        alt=""
        className="shape shape-1"
      />

      <img
        src="/assets/images/shape-9.png"
        width={21}
        height={22}
        loading="lazy"
        alt=""
        className="shape shape-2"
      />
    </section>
  );
};

export default SpecialDishSection;
